"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Supported Cell Types
 */
var DataCellTypes;
(function (DataCellTypes) {
    /**
     * Numbers only
     */
    DataCellTypes["Number"] = "number";
    /**
     * Takes a javascript date and displays long format "Wed, 14 Feb 2018 01:43:08 GMT"
     */
    DataCellTypes["LongDate"] = "date-long";
    /**
     * Takes a javascript date and disoplays relative format - e.g. 5 days left", "10 minutes ago"
     */
    DataCellTypes["RelativeDate"] = "date-relative";
    /**
     * Default type, converts value to string
     */
    DataCellTypes["String"] = "string";
})(DataCellTypes = exports.DataCellTypes || (exports.DataCellTypes = {}));
//# sourceMappingURL=types.js.map